module.exports = __webpack_public_path__ + "static/media/4.ea481885.JPG";